// Owner: meeting-recorder (owner feedback F15). Command bar (⌘K): meeting recordings and "search what was said".
// Loaded with the shell, so this file stays tiny; the items load on the first search.
import { defineAppCommands } from '../../extensions/commands';
import { moduleOn } from '../../lib/modules';

export default defineAppCommands({
  id: 'recorder',
  providers: [
    {
      id: 'recorder.go',
      items: async (query) => {
        // An optional workspace module: nothing while the recorder is off.
        if (!moduleOn('recorder')) return [];
        const { recorderCommandItems } = await import('./command-items');
        return recorderCommandItems(query);
      },
    },
  ],
});
